import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
  Grid,
} from "@mui/material";
import { setAllocationHandler } from "../ContractAction/AirDropContractAction";
import { toast } from "react-hot-toast";
const AllocationMuiDialog = ({
  timeOpen,
  handleClose,
  addr,
  setUpdate,
  update,
  decimals,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [amountMode, setAmountMode] = useState("fixed");
  const [fixedAmount, setFixedAmount] = useState("");
  const [minAmount, setMinAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState("");
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState();

  const handleChange = (event, generate = false) => {
    let input =
      typeof event?.target?.value === "string"
        ? event.target.value
        : inputValue;
    if (generate) {
      const addressList = input
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => /^0x[a-fA-F0-9]{40}/.test(line))
        .map((line) => line.split(" ")[0]);

      if (!addressList.length) return;

      const newAllocations = addressList.map((address) => {
        let amount;
        if (amountMode === "fixed") {
          amount = fixedAmount || "0";
        } else {
          const min = parseFloat(minAmount || "0");
          const max = parseFloat(maxAmount || "0");
          amount = (Math.random() * (max - min) + min).toFixed(0);
        }
        return `${address} ${amount}`;
      });
      input = newAllocations.join("\n");
      setInputValue(input);
    }
    const formattedInput = input
      .split("\n")
      .map((line) => {
        const parts = line.trim().split(/\s+/);
        if (parts.length === 1) {
          return `${parts[0]} `;
        } else if (parts.length === 2) {
          return `${parts[0].trim()} ${parts[1].trim()}`;
        }
        return line;
      })
      .join("\n");

    setInputValue(formattedInput);

    // Step 3: Parse into address-amount objects
    const entryList = formattedInput
      .split("\n")
      .map((line) => {
        const parts = line.trim().split(/\s+/);
        if (parts.length === 2) {
          const [address, amount] = parts;
          const numAmount = parseFloat(amount.trim());
          if (!isNaN(numAmount) && numAmount > 0) {
            return { address: address.trim(), amount: amount.trim() };
          }
        }
        return null;
      })
      .filter((entry) => entry !== null);

    setEntries(entryList);
  };

  console.log("entries", entries);
  const setAllocationHandlerFunction = async () => {
    console.log("!addr && !entries", addr, entries);

    if (!addr || !Array.isArray(entries) || entries.length === 0) {
      toast.error(
        "Please enter allocations or amount should be greater than 0"
      );
      return;
    }

    setLoading(true);
    const tx = await setAllocationHandler(addr, entries, decimals);
    if (tx) {
      setUpdate((prev) => !prev);
      setLoading(false);
      handleClose();
    }
    setLoading(false);
  };
  return (
    <Dialog
      open={timeOpen}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: "#242525",
          color: "white",
          maxWidth: "700px",
          width: "100%",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <DialogTitle sx={{ p: 0, mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Set Allocations
        </Typography>
      </DialogTitle>
      {/* Amount Generation Section */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="body2" sx={{ color: "#B0B0B0", mb: 1 }}>
          Amount Type
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4}>
            <Button
              variant={amountMode === "fixed" ? "contained" : "outlined"}
              onClick={() => setAmountMode("fixed")}
              fullWidth
              sx={{
                backgroundColor:
                  amountMode === "fixed" ? "#93C5FD" : "transparent",
                color: amountMode === "fixed" ? "#1F2937" : "#9CA3AF",
                borderColor: amountMode === "fixed" ? "transparent" : "#4B5563",
                "&:hover": {
                  backgroundColor:
                    amountMode === "fixed"
                      ? "#60A5FA"
                      : "rgba(255,255,255,0.05)",
                  borderColor:
                    amountMode === "fixed" ? "transparent" : "#9CA3AF",
                },
              }}
            >
              FIXED
            </Button>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Button
              variant={amountMode === "random" ? "contained" : "outlined"}
              onClick={() => setAmountMode("random")}
              fullWidth
              sx={{
                backgroundColor:
                  amountMode === "random" ? "#93C5FD" : "transparent",
                color: amountMode === "random" ? "#1F2937" : "#9CA3AF",
                borderColor:
                  amountMode === "random" ? "transparent" : "#4B5563",
                "&:hover": {
                  backgroundColor:
                    amountMode === "random"
                      ? "#60A5FA"
                      : "rgba(255,255,255,0.05)",
                  borderColor:
                    amountMode === "random" ? "transparent" : "#9CA3AF",
                },
              }}
            >
              RANDOM
            </Button>
          </Grid>
        </Grid>

        {amountMode === "fixed" ? (
          <Box className="mt-4">
            <TextField
              variant="outlined"
              fullWidth
              value={fixedAmount}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,18}$/.test(value)) {
                  setFixedAmount(value);
                }
              }}
              type="number"
              placeholder="0.0"
              sx={{
                "& .MuiInputBase-root": {
                  color: "white",
                  backgroundColor: "#2B2C2C",
                  borderRadius: "8px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#374151",
                },
              }}
            />
          </Box>
        ) : (
          <Grid container spacing={2} className="m-4">
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                value={minAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,18}$/.test(value)) {
                    setMinAmount(value);
                  }
                }}
                type="number"
                placeholder="Min"
                sx={{
                  "& .MuiInputBase-root": {
                    color: "white",
                    backgroundColor: "#2B2C2C",
                    borderRadius: "8px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#374151",
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                value={maxAmount}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,18}$/.test(value)) {
                    setMaxAmount(value);
                  }
                }}
                type="number"
                placeholder="Max"
                sx={{
                  "& .MuiInputBase-root": {
                    color: "white",
                    backgroundColor: "#2B2C2C",
                    borderRadius: "8px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#374151",
                  },
                }}
              />
            </Grid>
          </Grid>
        )}

        <Box className="mt-4">
          <Button
            variant="contained"
            onClick={() => handleChange(null, true)}
            sx={{
              backgroundColor: "#2B2C2C",
              color: "#93C5FD",
              "&:hover": { backgroundColor: "#374151" },
            }}
          >
            GENERATE ALLOCATIONS
          </Button>
        </Box>
      </Box>

      <DialogContent sx={{ p: 0 }}>
        <Box className="flex-col gap-4">
          <div>
            <Typography variant="body2" sx={{ color: "#B0B0B0", mb: 1 }}>
              Users Allocation
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={8}
              placeholder={`Insert allocations: separate with line breaks.\nFormat: address,amount or address amount\nExamples:\n0x00...00 13.56\n0x00...00 12.67`}
              variant="outlined"
              name="allocations"
              value={inputValue}
              onChange={handleChange}
              inputProps={{ style: { whiteSpace: "pre-wrap" } }}
              sx={{
                "& .MuiInputBase-root": {
                  color: "white",
                  backgroundColor: "#1F2937",
                  fontFamily: "monospace",
                  fontSize: "0.875rem",
                  borderRadius: "8px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "transparent",
                },
              }}
            />
          </div>
        </Box>
      </DialogContent>

      <DialogActions sx={{ pt: 3, px: 0 }}>
        <Button
          onClick={handleClose}
          sx={{
            color: "#9CA3AF",
            "&:hover": { color: "white" },
          }}
        >
          CANCEL
        </Button>
        <Button
          onClick={setAllocationHandlerFunction}
          color="primary"
          variant="contained"
          disabled={loading}
          sx={{
            backgroundColor: "#93C5FD",
            color: "#1F2937",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#60A5FA" },
          }}
        >
          {loading ? "SUBMITTING..." : "SUBMIT"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AllocationMuiDialog;
